import { NonProductionNotice } from './environment.model';

/** Imported only by the non-production environment files, so it tree-shakes out of production. */
export const NON_PRODUCTION_NOTICE: NonProductionNotice = {
  title: "This is a test site, not Kin's live site.",
  body:
    'If you are a Kin customer and reached this page from a link, that link was sent in error. ' +
    'Please do not enter any personal or payment details. Contact support and we will get you ' +
    'to the right place.',
};
